import { QueryClientProvider } from '@tanstack/react-query'
import { ErrorBoundary } from 'react-error-boundary'
import { RouterProvider } from 'react-router-dom'
import { useEffectOnce } from 'react-use'

import { queryClient } from './api'
import AppErrorBoundaryFallback from './common/AppErrorBoundaryFallback'
import { config } from './config'
import CosmosKitProvider from './contexts/CosmosKitProvider'
import { KeplrWalletProvider } from './contexts/KeplrWalletProvider'
import { ThemeProvider } from './contexts/ThemeProvider'
import { ErrorHandler } from './helpers'
import { createRouter } from './routes'

const router = createRouter()

export function App() {
  useEffectOnce(() => {
    try {
      if (config.VITE_APP_NAME) {
        document.title = config.VITE_APP_NAME
      }
    } catch (error) {
      ErrorHandler.processWithoutFeedback(error)
    }
  })

  return (
    <ThemeProvider>
      <CosmosKitProvider>
        <ErrorBoundary
          FallbackComponent={({ resetErrorBoundary }) => (
            <AppErrorBoundaryFallback onReset={resetErrorBoundary} />
          )}
          onReset={() => window.location.reload()}
        >
          <QueryClientProvider client={queryClient}>
            <KeplrWalletProvider>
              <RouterProvider router={router} />
            </KeplrWalletProvider>
          </QueryClientProvider>
        </ErrorBoundary>
      </CosmosKitProvider>
    </ThemeProvider>
  )
}
